import React from 'react';
import { AlertTriangle, CheckCircle2, History, Loader2, MinusCircle } from 'lucide-react';

const stateStyles = {
  NO_HISTORY: {
    icon: MinusCircle,
    container: 'border-slate-200 bg-slate-50',
    iconClass: 'text-slate-500',
  },
  SUCCESS_ONLY: {
    icon: CheckCircle2,
    container: 'border-emerald-200 bg-emerald-50/70',
    iconClass: 'text-emerald-600',
  },
  PRIOR_CANCELLATION: {
    icon: AlertTriangle,
    container: 'border-amber-200 bg-amber-50/80',
    iconClass: 'text-amber-600',
  },
  MULTIPLE_PRIOR_CANCELLATIONS: {
    icon: AlertTriangle,
    container: 'border-red-200 bg-red-50/80',
    iconClass: 'text-red-600',
  },
  PRIOR_REJECTION_ONLY: {
    icon: History,
    container: 'border-slate-200 bg-slate-50',
    iconClass: 'text-slate-600',
  },
  MIXED_HISTORY: {
    icon: History,
    container: 'border-slate-200 bg-slate-50',
    iconClass: 'text-slate-600',
  },
};

export default function RegistrationIntelligenceCard({ status, result, compact = false }) {
  if (!status || status === 'idle') return null;

  if (status === 'loading') {
    return (
      <div className="mt-3 flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-sm text-slate-600">
        <Loader2 className="h-4 w-4 animate-spin text-[#B1336E]" />
        <span className="font-montserrat">Consultando historial con tu tienda...</span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="mt-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-3">
        <p className="text-xs font-bold uppercase tracking-wide text-slate-500 font-montserrat">
          Historial con tu tienda
        </p>
        <p className="mt-1 text-xs text-slate-500 font-montserrat">
          No pudimos consultar el historial. Esto no impide registrar la entrega.
        </p>
      </div>
    );
  }

  if (!result) return null;
  const style = stateStyles[result.history_state] || stateStyles.NO_HISTORY;
  const Icon = style.icon;
  const history = result.recipient_history || {};

  return (
    <div className={`mt-3 rounded-xl border px-3 py-3 ${style.container}`}>
      <div className="flex items-start gap-2.5">
        <Icon className={`mt-0.5 h-4 w-4 flex-shrink-0 ${style.iconClass}`} />
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.12em] text-slate-500 font-montserrat">
            Historial con tu tienda
          </p>
          <p className="mt-0.5 text-sm font-bold text-slate-900 font-montserrat">
            {result.display?.title}
          </p>
          {!compact && (
            <p className="mt-1 text-xs leading-5 text-slate-600 font-montserrat">
              {result.display?.message}
            </p>
          )}
          {history.terminal_attempts > 0 && (
            <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs font-semibold text-slate-600 font-montserrat">
              <span>{history.delivered || 0} entregada{history.delivered === 1 ? '' : 's'}</span>
              <span className={history.cancelled ? 'text-red-700' : ''}>
                {history.cancelled || 0} cancelada{history.cancelled === 1 ? '' : 's'}
              </span>
              <span>{history.rejected || 0} rechazada{history.rejected === 1 ? '' : 's'}</span>
            </div>
          )}
          {history.cancelled > 0 && (
            <p className="mt-2 text-xs font-bold text-[#B1336E] font-montserrat">
              Recomendamos validar al destinatario. La entrega puede continuar.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

